import { render, staticRenderFns } from "./AddNewAvatarUser.vue?vue&type=template&id=6576b27f&scoped=true&"
import script from "./AddNewAvatarUser.vue?vue&type=script&lang=js&"
export * from "./AddNewAvatarUser.vue?vue&type=script&lang=js&"
import style0 from "./AddNewAvatarUser.vue?vue&type=style&index=0&id=6576b27f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6576b27f",
  null
  
)

export default component.exports